import React, { useEffect } from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getSession } from "./Slices/sessionSlice";

// #region Component Imports
import NavBar from "./components/Navbar/Navbar";
import CandidateScreenshots from "./views/CandidateScreenshots/CandidateScreenshots";
import CandidateDashBoard from "./views/candidate/CandidateDashbaord/CandidateDashBoard";
import LandingPage from "./views/public/LandingPage/LandingPage";
import SignUp from "./views/public/SignUp/SignUp";
import EmailVerificationPending from "./views/public/EmailVerificationPending/EmailVerificationPending";
import VerifyEmail from "./views/public/VerifyEmail/VerifyEmail";
import EmailAlreadyVerified from "./views/public/EmailAlreadyVerified/EmailAlreadyVerified";
import PrivateRoute from "./components/PrivateRoute/PrivateRoute";
import OrgAdminDashboard from "./views/OrgAdmin/Dashboard/Dashboard";
import OrgAdminReports from "./views/OrgAdmin/Reports/Reports";
import PageNotFound from "./views/public/PageNotFound/PageNotFound";
import CreateUser from "./views/Admin/CreateUser/CreateUser";
import EditUser from "./views/Admin/EditUser/EditUser";
import SupervisorDashboard from "./views/Supervisor/Dashboard/Dashboard";
import ProjectAssignmentView from "./views/OrgAdmin/ProjectAssignment/ProjectAssignment";
import SignIn from "./views/public/SignIn/SignIn";
import ForgotPassword from "./views/public/ForgotPassword/ForgotPassword";
import ResetPassword from "./views/public/ResetPassword/ResetPassword";
// #endregion

import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSession());
  }, []);

  return (
    <BrowserRouter>
      <NavBar />
      <Routes>
        <Route exact path="/" element={<LandingPage />} />
        <Route exact path="/sign-up" element={<SignUp />} />
        <Route exact path="/email-verification-pending" element={<EmailVerificationPending />} />
        <Route exact path="/verify-email" element={<VerifyEmail />} />
        <Route exact path="/email-already-verified" element={<EmailAlreadyVerified />} />
        <Route exact path="/sign-in" element={<SignIn />} />
        <Route exact path="/forgot-password" element={<ForgotPassword />} />
        <Route exact path="/reset-password" element={<ResetPassword />} />
        <Route
          exact
          path="/candidateScreenshots"
          element={
            <PrivateRoute
              allowedRoles={["Candidate", "OrgAdmin", "Supervisor"]}
              component={CandidateScreenshots}
              pageTitle="CandidateScreenshots"
            />
          }
        />
        <Route
          exact
          path="/admin/createUser"
          element={
            <PrivateRoute
              allowedRoles={["super-admin", "admin"]}
              component={CreateUser}
              pageTitle="CreateUser"
            />
          }
        />
        <Route
          exact
          path="/admin/editUser"
          element={
            <PrivateRoute
              allowedRoles={["super-admin", "admin"]}
              component={EditUser}
              pageTitle="EditUser"
            />
          }
        />
        <Route
          exact
          path="/candidateDashboard"
          element={
            <PrivateRoute
              allowedRoles={["Candidate"]}
              component={CandidateDashBoard}
              pageTitle="CandidateDashboard"
            />
          }
        />
        {/* --------------------------------- Org Admin ---------------------------------------*/}
        <Route
          exact
          path="/org-admin/dashboard"
          element={
            <PrivateRoute
              allowedRoles={["OrgAdmin"]}
              component={OrgAdminDashboard}
              pageTitle="OrgAdmin Dashboard"
            />
          }
        />
        <Route
          exact
          path="/org-admin/reports"
          element={
            <PrivateRoute
              allowedRoles={["OrgAdmin"]}
              component={OrgAdminReports}
              pageTitle="OrgAdmin Reports"
            />
          }
        />
        <Route
          exact
          path="/org-admin/project-assignment"
          element={
            <PrivateRoute
              allowedRoles={["OrgAdmin"]}
              component={ProjectAssignmentView}
              pageTitle="OrgAdmin Project Assignment"
            />
          }
        />
        {/* ------------------------------- Supervisor ----------------------------------- */}
        <Route
          exact
          path="/supervisor/dashboard"
          element={
            <PrivateRoute
              allowedRoles={["Supervisor"]}
              component={SupervisorDashboard}
              pageTitle="Supervisor Dashboard"
            />
          }
        />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
